import { Typography, Box } from '@mui/material';

export default function QuoteBlock({ block }: { block: any }) {
    return (
        <Box
            sx={{
                padding: "100px 0px",
                borderTop: "1px solid #303030",
                borderBottom: "1px solid #303030",
                textAlign: "center",
            }}
        >
            <Typography
                sx={{
                color: "rgb(128, 128, 128)",
                fontSize: "clamp(22px, 2.5vw, 28px)",
                maxWidth: "720px",
                margin: "0 auto",
                whiteSpace: "pre-wrap",
                width: { sm: "100%", md: "520px" },
                wordBreak: "break-word",
                overflowWrap: "break-word",
                }}
            >
                {block.text}
            </Typography>
        </Box>
    );
}